import { isExpired, DAY } from 'lib/expirationHelpers';

const COHORT_KEY = 'gladlyCohort-';

export default class CohortGateway {
  createKey(appId) {
    return `${COHORT_KEY}${appId}`;
  }

  setCohortId(appId, cohortValue) {
    const key = this.createKey(appId);

    localStorage.setItem(key, JSON.stringify({ cohortValue, createdAt: Date.now() }));

    return cohortValue;
  }

  getCohortId(appId) {
    const key = this.createKey(appId);
    let cohortItem = localStorage.getItem(key);

    if (!cohortItem) {
      return null;
    }

    cohortItem = JSON.parse(cohortItem);

    if (isExpired(cohortItem.createdAt, DAY)) {
      localStorage.removeItem(key);
      return null;
    }

    return cohortItem.cohortValue;
  }
}
